import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { RegistroService } from 'src/app/registro.service';

@Directive({
  selector: '[appPermiso]',
})
export class PermisoDirective implements OnInit, OnDestroy {
  private subscription?: Subscription;
  private requiredPermission = '';
  private hasView = false;

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly registroService: RegistroService,
  ) {}

  @Input('appPermiso')
  set appPermiso(permiso: string) {
    this.requiredPermission = (permiso ?? '').trim();
    this.updateView();
  }

  ngOnInit(): void {
    this.subscription = this.registroService.permisos$.subscribe(() => {
      this.updateView();
    });
    this.updateView();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private updateView(): void {
    const canShow = this.hasPermission();
    if (canShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!canShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private hasPermission(): boolean {
    if (!this.requiredPermission) {
      return true;
    }

    const permisos = this.registroService.permisos;
    if (!Array.isArray(permisos)) {
      return false;
    }

    return permisos.some((permiso: unknown) => {
      if (typeof permiso === 'string') {
        return permiso === this.requiredPermission;
      }

      if (permiso && typeof permiso === 'object') {
        const codigo = (permiso as { codigo?: unknown }).codigo;
        return typeof codigo === 'string' && codigo === this.requiredPermission;
      }

      return false;
    });
  }
}